import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';
import { BaseApolloResponse } from '@customer-portal/shared/models/response/base-apollo.response';

import { SITE_NICKNAME_MUTATION } from '../../graphql';
import { SaveSiteNicknamePayload } from '../../models';

@Injectable()
export class SettingsSiteNicknameService {
  private readonly clientName = 'contact';

  constructor(private readonly apollo: Apollo) {}

  saveSiteNickname({
    siteId,
    siteNickname,
  }: SaveSiteNicknamePayload): Observable<BaseApolloResponse<boolean> | null> {
    const fieldName =
      getQueryRootFieldName(SITE_NICKNAME_MUTATION) || 'saveSiteNickname';

    return this.apollo
      .use(this.clientName)
      .mutate<{ SaveSiteNickName: BaseApolloResponse<boolean> }>({
        mutation: SITE_NICKNAME_MUTATION,
        variables: { request: { siteId: Number(siteId), siteNickname } },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result?.data?.SaveSiteNickName),
      );
  }
}
